<template>
  <div class="layout_menu">
    <Header/>
    <Flash v-if="$store.state.flash_message"/>
    <div id="router-view-login-frame">
      <router-view/>
      <Footer/>
    </div>
  </div>
</template>

<script>
import Header from '@/elements/logout/Header.vue'
import Footer from '@/elements/logout/Footer.vue'
import Flash from '@/elements/Flash.vue'

export default {
  components: {
    Footer, Header, Flash
  }
}
</script>
